import {ISubNavLink} from "modules/types/routing";

export const subMenuRouting: ISubNavLink[] = [
	{
		title: "sub_header.links.landing",
		href: "/",
	},
	{
		title: "sub_header.links.badges",
		href: "/badges",
		isPrivate: true,
	},
	{
		title: "sub_header.links.profile",
		href: "/profile",
		isPrivate: true,
	},
	{
		title: "sub_header.links.help",
		href: "/help",
	},
];
